export default __webpack_public_path__ + "static/media/plain-sticker-Q.2cb73b0b.png";